import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import { togglePaymentModal } from './actions';
import Modal from './index';
import Bill from './Payment/Bill';

@connect(
  state => ({
    bills: state.bills.bills,
  }),
  dispatch => ({
    toggleModal() {
      return dispatch(togglePaymentModal());
    },
  }),
)
@translate(['modal'], { wait: true })
export class PaymentModal extends Modal {
  toggleModal = (e) => {
    e.preventDefault();
    this.props.toggleModal();
  };


  render() {
    const { bills, t } = this.props;

    return (
      <div className="popapWrapper popapDefaultWrapper active">
        <div ref="modal" className="popup popup_type_payments">
          <a role="presentation" className="popup__close" onClick={this.toggleModal} />
          <form action="#" className="popupForm popupForm-content">
            <div className="stepTitle">
              <h2>{t('modal:bills__title')}</h2>
            </div>
            <ul className="invoices-list">
              {bills.map(bill => (
                <Bill
                  key={bill.orderId}
                  onProceedToPayment={this.proceedToPayment}
                  bill={bill}
                  amountText={t('common:price', { number: bill.amount || 0 })}
                />
              ))}
            </ul>
          </form>
        </div>
        <a role="presentation" onClick={this.toggleModal} href="#close" className="overlay" />
      </div>
    );
  }
}

PaymentModal.PropTypes = {
  bill: PropTypes.object,
  toggleModal: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/Modal/PaymentModal.js